import { FunctionComponent } from 'react'
import { PriceBreakdown } from 'src/modules/MyPlan/components/OrderSummary/components/PriceBreakdown/PriceBreakdown'
import { PriceBreakdownItem } from 'src/modules/MyPlan/components/OrderSummary/components/PriceBreakdownItem/PriceBreakdownItem'
import { Banner } from '../Banner/Banner'
import { CalendarSelector } from '../CalendarSelector/CalendarSelector'
import { ChefRowCard } from '../ChefRowCard/ChefRowCard'
import { CollectionRowCard } from '../CollectionRowCard/CollectionRowCard'
import { Concept } from '../Concept/Concept'
import { HeroBanner } from '../HeroBanner/HeroBanner'
import NoItemsCard from '../NoItemsCard/NoItemsCard'
import { OrderStatusCard } from '../OrderStatusCard/OrderStatusCard'
import { Button } from '../primitives/Button/Button'
import { Icon } from '../primitives/Icon/Icon'
import { Image } from '../primitives/Image/Image'
import { Label } from '../primitives/Label/Label'
import { LazyLoader } from '../primitives/LazyLoader/LazyLoader'
import { Text } from '../primitives/Text/Text'
import { ProductCard } from '../ProductCard/ProductCard'
import { ProductCardCollapsed } from '../ProductCardCollapsed/ProductCardCollapsed'
import { QuickFilter } from '../QuickFilter/QuickFilter'
import { SearchBar } from '../SearchBar/SearchBar'
import { Section } from '../Section/Section'
import { Separator } from '../Separator/Separator'
import { Swimlane } from '../Swimlane/Swimlane'
import { UXComponent } from './uxComponent'
import { UXComponentType } from './uxComponent.types'

// Tab will be registered dynamically to avoid circular dependency
let TabComponent: FunctionComponent<UXComponent> | null = null

// Component mapping
export const getComponentByType = () => {
  const componentByType: Record<string, FunctionComponent<UXComponent>> = {
    [UXComponentType.Button]: Button as FunctionComponent<UXComponent>,
    [UXComponentType.Icon]: Icon as FunctionComponent<UXComponent>,
    [UXComponentType.Label]: Label as FunctionComponent<UXComponent>,
    [UXComponentType.Text]: Text as FunctionComponent<UXComponent>,
    [UXComponentType.Image]: Image as FunctionComponent<UXComponent>,
    [UXComponentType.Swimlane]: Swimlane as FunctionComponent<UXComponent>,
    [UXComponentType.Section]: Section as FunctionComponent<UXComponent>,
    [UXComponentType.Calendar]: CalendarSelector as FunctionComponent<
      UXComponent
    >,
    [UXComponentType.SearchBar]: SearchBar as FunctionComponent<UXComponent>,
    [UXComponentType.QuickFilter]: QuickFilter as FunctionComponent<
      UXComponent
    >,
    [UXComponentType.Concept]: Concept as FunctionComponent<UXComponent>,
    [UXComponentType.ChefRowCard]: ChefRowCard as FunctionComponent<
      UXComponent
    >,
    [UXComponentType.CollectionRowCard]: CollectionRowCard as FunctionComponent<
      UXComponent
    >,
    [UXComponentType.Banner]: Banner as FunctionComponent<UXComponent>,
    [UXComponentType.HeroBanner]: HeroBanner as FunctionComponent<UXComponent>,
    [UXComponentType.ProductCard]: ProductCard as FunctionComponent<
      UXComponent
    >,
    [UXComponentType.ProductCardCollapsed]: ProductCardCollapsed as FunctionComponent<
      UXComponent
    >,
    [UXComponentType.LazyLoader]: LazyLoader as FunctionComponent<UXComponent>,
    [UXComponentType.OrderStatusCard]: OrderStatusCard as FunctionComponent<
      UXComponent
    >,
    [UXComponentType.NoItemsCard]: NoItemsCard as FunctionComponent<
      UXComponent
    >,
    [UXComponentType.Separator]: Separator as FunctionComponent<UXComponent>,
    [UXComponentType.PriceBreakdown]: PriceBreakdown as FunctionComponent<
      UXComponent
    >,
    [UXComponentType.PriceBreakdownItem]: PriceBreakdownItem as FunctionComponent<
      UXComponent
    >
  }

  // Only add Tab component if it has been registered
  if (TabComponent) {
    componentByType[UXComponentType.Tab] = TabComponent
  }

  return componentByType
}
